import React, { useState, Dispatch } from "react";
import "react-image-lightbox/style.css";
import { ImagesShop } from "./ImagesShop";
import ImageLoadingCard from "./ImageLoadingCard";
import { connect, ConnectedProps } from "react-redux";
import {
  fetchExpansionsInfo,
  addExpansion,
  fetchExpansionsImages
} from "../../redux/actions/ExpansionsActions";
import {
  PREMIUM1_EXPANSION,
  PREMIUM2_EXPANSION,
  FREE_EXPANSION
} from "../../constants/expansions";
import {
  ExpansionsActionInterface,
  ExpansionInterface
} from "../../redux/reducers/ExpansionsReducers";

interface actionsType {
  fetchExpansionsInfo: () => (
    dispatch: Dispatch<ExpansionsActionInterface>
  ) => void;
  addExpansion: (
    expansionName: string
  ) => (
    dispatch: Dispatch<{
      type: string;
    }>
  ) => void;
  fetchExpansionsImages: () => (
    dispatch: Dispatch<ExpansionsActionInterface>
  ) => void;
}
interface RootState {
  expansion: ExpansionInterface;
}

const actionsReducers: actionsType = {
  fetchExpansionsInfo,
  addExpansion,
  fetchExpansionsImages
};

const mapStateToProps = (state: RootState) => ({
  expansion: state.expansion
});

const connector = connect(mapStateToProps, actionsReducers);

type PropsFromRedux = ConnectedProps<typeof connector>;

interface ShopProps {}

function Shop(props: ShopProps & PropsFromRedux) {
  const premium1Images = props.expansion.expansions
    ? props.expansion.expansions[PREMIUM1_EXPANSION]
    : ({} as { count: number; images: string[] });
  const premium2Images = props.expansion.expansions
    ? props.expansion.expansions[PREMIUM2_EXPANSION]
    : ({} as { count: number; images: string[] });
  const freeImages = props.expansion.expansions
    ? props.expansion.expansions[FREE_EXPANSION]
    : ({} as { count: number; images: string[] });
  const [freeIndex, setFreeIndex] = useState(0);
  const [isFreeOpen, setIsFreeOpen] = useState(false);
  const [premium1Index, setPremium1Index] = useState(0);
  const [isPremium1Open, setIsPremium1Open] = useState(false);
  const [premium2Index, setPremium2Index] = useState(0);
  const [isPremium2Open, setIsPremium2Open] = useState(false);

  return (
    <div>
      <h4>Shopping</h4>
      <div className="containerCardImages">
        {freeImages.images.length > 0 && props.expansion.info ? (
          <ImagesShop
            isBought={props.expansion.info[FREE_EXPANSION]}
            title="Free Images"
            setIsOpen={setIsFreeOpen}
            images={freeImages.images}
            imageIndex={freeIndex}
            isOpen={isFreeOpen}
            setImageIndex={setFreeIndex}
          />
        ) : (
          <ImageLoadingCard />
        )}
        {premium1Images.images.length > 0 && props.expansion.info ? (
          <ImagesShop
            isBought={props.expansion.info[PREMIUM1_EXPANSION]}
            title="Premium 1"
            setIsOpen={setIsPremium1Open}
            images={premium1Images.images}
            imageIndex={premium1Index}
            isOpen={isPremium1Open}
            setImageIndex={setPremium1Index}
            onBuy={() => props.addExpansion(PREMIUM1_EXPANSION)}
          />
        ) : (
          <ImageLoadingCard />
        )}
        {premium2Images.images.length > 0 && props.expansion.info ? (
          <ImagesShop
            isBought={props.expansion.info[PREMIUM2_EXPANSION]}
            title="Premium 2"
            setIsOpen={setIsPremium2Open}
            images={premium2Images.images}
            imageIndex={premium2Index}
            isOpen={isPremium2Open}
            setImageIndex={setPremium2Index}
            onBuy={() => props.addExpansion(PREMIUM2_EXPANSION)}
          />
        ) : (
          <ImageLoadingCard />
        )}
      </div>
    </div>
  );
}

export default connector(Shop);
